<template>
  <section class="page-container">
    <div class="flex-sb-center mg-b-30">
      <span class="title">Create Quote For</span>
      <v-button
        green
        @click="handleNext">Next</v-button>
    </div>
    <select-quote-type
      v-model="selectType"
      disable></select-quote-type>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import {getQuoteAllNew} from '@api/quote'
import SelectQuoteType from '../components/select-quote-type'
export default {
  name: 'select-for-quote',
  components:{
    SelectQuoteType
  },
  mixins: [MixinOptions, MixinRules,MixinFormat],
  data(){
    return{
      selectType:'1',
      formData:{}
    }
  },
  computed:{
    severType(){
      return this.selectType==1?'holdcover':'fina'
    },
    hasCustomer(){
      let {hasCustomer} = this.$route.query||{}
      return hasCustomer
    }
  },
  methods:{
    handleNext(){
      let params = {}
      if(this.hasCustomer){
        params.hasCustomer  = true
      }
      this.$router.push({
        path:`/quoting/${this.severType}/index`,
        query:{
          ...params
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.page-container{
  padding: 30px 70px;
  .title{
    font-weight: 600;
    font-size: 36px;
    color: $dark;
  }

}

</style>
